//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TenantDrawer from "./modules/TenantDrawer";
import TenantStreamingMediaDrawer from "./modules/TenantStreamingMediaDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from "@api/manage";
export default {
  name: 'TenantList',
  mixins: [JeecgListMixin],
  components: {
    TenantDrawer: TenantDrawer,
    TenantStreamingMediaDrawer: TenantStreamingMediaDrawer
  },
  data: function data() {
    return {
      pagePath: '/sys/tenant',
      pageTitle: '租户表',
      // 表头
      columns: [// {
      //     title: '序号',
      //     dataIndex: '',
      //     key:'rowIndex',
      //     width:60,
      //     align:"center",
      //     customRender:function (t,r,index) {
      //         return parseInt(index)+1;
      //     }
      // },
      {
        dataIndex: 'id',
        colName: 'id',
        title: '租户ID',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '租户编号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '企业名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '租户域名',
        align: 'center',
        sorter: true,
        customRender: function customRender(text, record, index) {
          return "https://yesep.online/login/" + text;
        }
      }, {
        dataIndex: 'phone',
        colName: 'phone',
        title: '联系电话',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'startTime',
        colName: 'start_time',
        title: '开始时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'endTime',
        colName: 'end_time',
        title: '结束时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    onDateStartTime: function onDateStartTime(value, dateArray) {
      this.queryParam.onDateStart = dateArray[0];
      this.queryParam.onDateEnd = dateArray[1];
    },
    onDateEndTime: function onDateEndTime(value, dateArray) {
      this.queryParam.offDateStart = dateArray[0];
      this.queryParam.offDateEnd = dateArray[1];
    },
    handleStreamingMedia: function handleStreamingMedia(record) {
      this.loadTenantStreamingMedia(record.id);
    },
    loadTenantStreamingMedia: function loadTenantStreamingMedia(tenantId) {
      var _this = this;

      getAction('/tenant/streaming/media/queryTenantStreamingMedia/' + tenantId).then(function (res) {
        if (res.success) {
          _this.$refs.streamingMedia.title = '编辑：' + _this.pageTitle;
          _this.$refs.streamingMedia.disableSubmit = false;
          _this.$refs.streamingMedia.showTab = true;
          _this.$refs.streamingMedia.showContact = true;
          var params = {
            tenantId: tenantId
          };

          if (res.result) {
            _this.$refs.streamingMedia.edit(res.result);
          } else {
            _this.$refs.streamingMedia.edit(params);
          }
        }
      });
    }
  }
};